<template>
  <div
    :class="[
      'game',
      'game-1toN',
      (status !== undefined || showSolution) && 'game-finished',
    ]"
  >
    <h2>
      One {{ gameSrcLang.toUpperCase() }} - Many
      {{ gameTargetLang.toUpperCase() }}
    </h2>
    <div class="words-lists">
      <ul class="words">
        <li class="word">
          <div
            :class="'word-src word-' + gameSrcLang"
            :title="selectedWord[gameTargetLang]"
          >
            <icelandic-term
              v-if="gameSrcLang === 'is'"
              :term="selectedWord[gameSrcLang]"
            />
            <span v-else> {{ selectedWord[gameSrcLang] }}</span>
          </div>
        </li>
      </ul>
      <ul class="choices">
        <li
          class="choice"
          v-for="(word, index) in shuffledSelectedWords"
          :key="'one-to-many-' + word[gameSrcLang]"
          :data="word[gameTargetLang]"
        >
          <label
            :class="[
              'input-container',
              showSolution &&
                word[gameSrcLang] == selectedWord[gameSrcLang] &&
                'solution',
            ]"
            @click="onClick($event, word)"
            :title="word[gameSrcLang]"
          >
            <div :class="'choice-' + gameSrcLang">
              <icelandic-term
                v-if="gameTargetLang === 'is'"
                :term="word[gameTargetLang]"
              />
              <span v-else>{{ word[gameTargetLang] }}</span>
            </div>

            <input
              type="radio"
              name="radio"
              :checkeeed="
                showSolution && word[gameSrcLang] == selectedWord[gameSrcLang]
              "
              :disabled="showSolution && 'disabled'"
            />
            <span class="radio-checkmark"></span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IcelandicTerm from "@/components/IcelandicTerm.vue";
import { mapGetters } from "vuex";

export default {
  name: "GameOneToMany",
  components: { IcelandicTerm },
  data() {
    const emptyWord = {};
    emptyWord[this.gameSrcLang] = "";
    emptyWord[this.gameTargetLang] = "";
    return {
      emptyWord,
      target: "",
      status: undefined,
      showSolution: false,
      errors: 0,
    };
  },
  computed: {
    ...mapGetters([
      "gameSrcLang",
      "gameTargetLang",
      "gameAllowedErrors",
      "selectedWords",
      "shuffledSelectedWords",
    ]),
    selectedWord() {
      if (this.selectedWords.length == 0) return this.emptyWord;
      for (let word of this.selectedWords) {
        if (word.failed) return word;
      }
      return this.selectedWords[0];
    },
  },
  created() {
    // console.log(
    //   `created ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
    // );
    this.$store.subscribe((mutation, state) => {
      if (["CATEGORY_SELECTED", "NEW_GAME"].includes(mutation.type)) {
        this.initGame();
      }
    });
  },
  methods: {
    onClick(e, word) {
      e.preventDefault();
      if (this.showSolution || this.status == false) return;
      this.setGameStatus(
        word[this.gameTargetLang] === this.selectedWord[this.gameTargetLang]
      );
    },
    initGame() {
      console.log(
        `GameOneToMany initGame ${this.gameSrcLang.toUpperCase()} to ${this.gameTargetLang.toUpperCase()}`
      );

      this.showSolution = false;
      this.target = "";
      this.setGameStatus(undefined);
      this.errors = 0;
    },
    setGameStatus(status) {
      if (status === false) {
        this.$store.dispatch("failedWord", this.selectedWord);
        this.errors++;
        if (this.errors < this.gameAllowedErrors) return;
      }
      this.status = status;
      this.$emit("gameStatus", status);
    },
    solution() {
      this.showSolution = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/scss/components-shared.scss";
@import "@/scss/shared-radio-check.scss";

.words-lists {
  display: inline-flex;
  align-items: center;
}
.words,
.choices {
  list-style: none;
}
.words {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.words .word {
  display: flex;
  height: 32px;
  align-items: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.word-target {
  margin-left: 1rem;
  background-color: #aaa;
  height: 32px;
  min-width: 32px;
  border-radius: 16px;
}
.word-target-ok {
  background-color: green;
  color: white;
}
.word-target-error {
  background-color: red;
  color: white;
}
.word-target-ok,
.word-target-error {
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.choices {
  margin-left: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.choices .choice {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: left;
  font-style: italic;
}

.game-finished
  .input-container:not(.solution):hover
  input:not(:checked)
  ~ .radio-checkmark {
  background-color: #eee !important;
}
.input-container.solution input ~ .radio-checkmark {
  background-color: orange !important;
}
</style>
